import {makeObservable, observable, runInAction} from "mobx";
import {ToastMessageStatus} from "../../../components/atoms/toastMessage/toastMessage";

export interface IToastMessageStore {
  isOpen: boolean;
  message: string;
  header: string;
  status: ToastMessageStatus;
  displayToastMessage: (
    message: string,
    status: ToastMessageStatus,
    dismissTimeoutInMs?: number,
    header?: string
  ) => void;
  dismiss: () => void;
}

/**
 * Store that controls the toast message.
 */
export class ToastMessageStore implements IToastMessageStore {
  isOpen: boolean;
  message: string;
  status: ToastMessageStatus;
  dismissTimeoutInMs: number;
  header: string;

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      message: observable,
      status: observable,
      header: observable
    });
    this.isOpen = false;
    this.message = "";
    this.status = ToastMessageStatus.Virtual;
    this.dismissTimeoutInMs = 5000;
    this.header = "";
  }

  /**
   * Dismiss the toast message manually.
   */
  dismiss = () => {
    this.isOpen = false;
  };

  /**
   * Display toast message.
   * @param message - message to be displayed.
   * @param status - status of the toast message.
   * @param dismissTimeoutInMs - time in milliseconds before the toast message is dismissed automatically.
   */
  displayToastMessage = (
    message: string,
    status: ToastMessageStatus,
    dismissTimeoutInMs = this.dismissTimeoutInMs,
    header = this.header
  ) => {
    runInAction(() => {
      this.message = message;
      this.status = status;
      this.isOpen = true;
      this.header = header;
    });
    setTimeout(() => {
      runInAction(() => (this.isOpen = false));
    }, dismissTimeoutInMs);
  };
}
